// src/theme.ts
import { createTheme } from "@mui/material/styles";

export const androidTheme = createTheme({
  palette: {
    primary: { main: "#6750A4" },
    secondary: { main: "#625B71" },
    background: { default: "#FFFBFE" },
    error: { main: "#B3261E" },
  },
  shape: { borderRadius: 12 },
  spacing: 4, // dp grid
  typography: {
    fontFamily: "Roboto, system-ui, -apple-system, Segoe UI",
  },
  // elevation mapping can be customized via shadows
  shadows: [
    "none",
    "0px 1px 2px rgba(0,0,0,0.12)",
    "0px 2px 4px rgba(0,0,0,0.12)",
    "0px 3px 6px rgba(0,0,0,0.12)",
    "0px 4px 8px rgba(0,0,0,0.12)",
    "0px 5px 10px rgba(0,0,0,0.12)",
  ] as any,

});